<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">
      Подъезд {{ block.number }}
      <router-link class="btn btn-primary" :to="{ name: 'block-edit', params: { block_id: block.id }}">Редактировать подъезд</router-link>
    </h2>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'building-details', params: { building_id: $route.params.building_id } }">← Назад к Подъездам</router-link>
    </div>

    <div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Начальная дата</label>
            <el-date-picker
              v-model="dateFrom"
              input-id="date-from"
              input-class="form-control"
              type="date"
              placeholder="Начальная дата">
            </el-date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Конечная дата</label>
            <el-date-picker
              v-model="dateTo"
              input-id="date-to"
              input-class="form-control"
              type="date"
              placeholder="Конечная дата">
            </el-date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Количество месяцев</label>
            <input type="text" class="form-control" v-model="months">
          </div>
        </div>
        <div class="col-md-3">
          <div style="margin-top: 25px;" class="text-right">
            <a class="btn btn-primary" href="#" @click.prevent="printBills">напечатать квитанции</a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Начальная дата 2</label>
            <el-date-picker
              v-model="dateFrom2"
              input-id="date-from2"
              input-class="form-control"
              type="date"
              placeholder="Начальная дата 2">
            </el-date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Конечная дата 2</label>
            <el-date-picker
              v-model="dateTo2"
              input-id="date-to2"
              input-class="form-control"
              type="date"
              placeholder="Конечная дата 2">
            </el-date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Количество месяцев 2</label>
            <input type="text" class="form-control" v-model="months2">
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label>Тарифный план</label>
          <el-select
            v-model="ratePlan"
            filterable>
            <el-option value="" label="- Все -"></el-option>
            <el-option
              v-for="option in selectRatePlans"
              :key="option.value"
              :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="text-right">
          <a class="red" href="#" @click.prevent="applyRatePlan">применить тарифный план</a>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label>Дата снятия абонплаты</label>
          <el-date-picker
              v-model="bill_datetime"
              input-id="bill-datetime"
              input-class="form-control"
              type="datetime"
              placeholder="Выберите дату и время">
            </el-date-picker>
        </div>
      </div>
      <div class="col-md-3">
        <div class="text-right" style="margin-top: 15px;">
          <a class="red" href="#" @click.prevent="applyBilling">применить снятие абонплаты</a>
        </div>
      </div>
    </div>

    <div v-if="false" class="row">
      <div class="col-md-6">

        <!-- Full name -->
        <div class="form-group">
          <label>Полный адрес</label>
          <p>{{ block.full_name }}</p>
        </div>

      </div>
      <div class="col-md-6">

        <!-- Number -->
        <div class="form-group">
          <label>Номер подъезда</label>
          <p>{{ block.number }}</p>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <router-view :block-id="block.id"></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import { getBlock, applyRatePlan, printBills, applyBilling } from '@/services/block.service'
import { getList } from '@/services/__common.service'

export default {
  name: 'block-details',
  data () {
    return {
      months: '',
      dateFrom: '',
      dateTo: '',
      months2: 1,
      dateFrom2: null,
      dateTo2: null,
      ratePlan: '',
      selectRatePlans: [],

      bill_datetime: null,

      block: {
        id: null,
        number: '',
        full_name: ''
      }
    }
  },
  mounted () {
    if (this.$route.params.block_id !== undefined) {
      this.block.id = this.$route.params.block_id

      getBlock(this.block.id).then((response) => {
        this.block = response.data
      })
    }

    getList('/rate-plans', 'name', 'asc', {}, true, 1, 100).then((response) => {
      this.selectRatePlans = response.data['results'].map(ratePlan => {
        return { value: ratePlan.id, label: ratePlan.name }
      })
    })
  },
  methods: {
    printBills () {
      let dateFrom
      let dateTo
      let dateFrom2
      let dateTo2

      if (this.dateFrom) {
        dateFrom = this.dateFrom.toJSON()
      } else {
        dateFrom = this.dateFrom
      }
      if (this.dateTo) {
        dateTo = this.dateTo.toJSON()
      } else {
        dateTo = this.dateTo
      }

      if (this.dateFrom2) {
        dateFrom2 = this.dateFrom2.toJSON()
      } else {
        dateFrom2 = this.dateFrom2
      }
      if (this.dateTo2) {
        dateTo2 = this.dateTo2.toJSON()
      } else {
        dateTo2 = this.dateTo2
      }

      printBills(this.block.id, this.months, dateFrom, dateTo, this.months2, dateFrom2, dateTo2).then((response) => {
        let file = new Blob([response.data], {type: 'application/pdf'})
        let fileURL = URL.createObjectURL(file)
        window.open(fileURL)
      }).catch(err => {
        console.log(err.response)
      })
    },
    applyRatePlan () {
      applyRatePlan(this.block.id, this.ratePlan).then((response) => {
        this.showMsg('Тарифный план был успешно применен!', 'success', 'Успех')
      }).catch(err => {
        console.log(err)
        this.showMsg('Возникла непредвиденная ошибка!', 'error', 'Ошибка')
      })
    },
    applyBilling () {
      let billDateTime

      if (this.bill_datetime) {
        billDateTime = this.bill_datetime.toJSON()
      } else {
        billDateTime = this.bill_datetime
      }

      applyBilling(this.block.id, billDateTime).then((response) => {
        this.showMsg('Снятие абонплаты было успешно проведено!', 'success', 'Успех')
      }).catch(err => {
        console.log(err)
        this.showMsg(err.response.data['non_field_errors'][0], 'error', 'Ошибка')
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// BlockDetails.vue?9e5dc768